export default "__VITE_ASSET__fRmTLPnO__"